import errorManager from '@/rollbar.js';

const handleSubmit = (data_ora_fine_pratica, confirmText) => {
  $('.form-domestic-agenda').on('submit', function (e) {
    if (!data_ora_fine_pratica || data_ora_fine_pratica == 0) return;
    e.preventDefault();
    const dataInput = moment(`${$('#activity_planned_date').val()} ${$('#activity_planned_time').val()}`, 'DD/MM/YYYY HH:mm');
    const dataOraFinePratica = new Date(data_ora_fine_pratica * 1000);

    const showAlert = dataOraFinePratica < dataInput;
    if (showAlert) {
      if (!confirm(confirmText)) e.stopPropagation();
    }
  });
};

const init = (enableAlert, data_ora_fine_pratica, confirmText) => {
  if (!enableAlert || enableAlert == 'false') return;
  try {
    handleSubmit(data_ora_fine_pratica, confirmText);
  } catch (e) {
    errorManager(e);
  }
};

window.DomesticAlertEditActivity = {
  init: init,
};
